export default "__VITE_ASSET__35ece47c__"